export default "__VITE_ASSET__c1a1023b__"